{
  "name": "shiva-exploit",
  "version": "2.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o --proxy-config proxy.config.json --configuration=gnvert",
    "start:integration": "ng serve -o --configuration=integration",
    "start:prod": "ng serve -o --proxy-config proxy.config.json --browser-target=shiva-exploit:build:prod,gnvert",
    "start:local": "ng serve -o --proxy-config proxy.config.json --browser-target=shiva-exploit:build:local,gnvert",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/shiva-exploit/stats.json",
    "linter": "ng lint --fix",
    "build": "ng build",
    "build:integration": "ng build --output-hashing=all --configuration=integration,gnvert",
    "build:prod": "ng build --output-hashing=all --configuration=prod,gnvert",
    "build:local": "ng build --configuration=gnvert,local",
    "build:gnvert": "ng build --configuration=gnvert",
    "swagger-gen": "ng-openapi-gen -c ng-swagger-gen-web-secured.json && ng-openapi-gen -c ng-swagger-gen-web-public.json",
    "swagger-vnf": "ng-openapi-gen -c ng-swagger-shiva-vnf-secured.json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e --configuration=integration",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/compiler-cli": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/google-maps": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@cubejs-client/core": "^1.7.37",
    "@cubejs-client/ngx": "^1.7.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@okta/okta-angular": "^8.0.0",
    "@okta/okta-auth-js": "^8.0.1",
    "@types/file-saver": "^2.0.1",
    "@types/google.maps": "3.58.1",
    "@types/googlemaps": "^3.43.3",
    "@types/leaflet": "^1.7.5",
    "@types/node": "^20.0.0",
    "chart.js": "^4.5.1",
    "core-js": "^3.17.2",
    "dayjs": "^1.11.23",
    "echarts": "^5.2.0",
    "file-saver": "^2.0.2",
    "jwt-decode": "^3.1.2",
    "leaflet": "^1.7.1",
    "lodash": "^4.17.11",
    "moment": "^2.30.1",
    "ng-openapi-gen": "^0.53.0",
    "ng2-charts": "^6.0.1",
    "ng2-date-picker": "^21.0.1",
    "ngx-cookie-service": "^22.0.0",
    "ngx-device-detector": "^12.0.0",
    "ngx-echarts": "^22.0.0",
    "ngx-logger": "^5.0.12",
    "ngx-quill": "^22.1.2",
    "ngx-spinner": "^22.0.1",
    "popper.js": "1.14.7",
    "quill": "^1.3.7",
    "quill-mention": "^3.2.0",
    "rxjs": "^7.8.0",
    "simple-crypto-js": "2.2.0",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^22.0.1",
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "angular-eslint": "^22.5.0",
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular/build": "^22.1.8",
    "@angular/cli": "22.1.8",
    "@angular/language-service": "22.1.6",
    "@cypress/schematic": "2.5.2",
    "@eslint/js": "^9.0.0",
    "@types/jest": "^30.0.0",
    "@types/quill": "1.3.10",
    "cypress": "^16.1.0",
    "eslint": "^9.0.0",
    "jest": "^30.5.1",
    "jest-environment-jsdom": "^30.5.1",
    "jest-preset-angular": "^17.0.0",
    "json-server": "^0.16.3",
    "ng-mocks": "^14.17.3",
    "ngx-translate-testing": "7.0.0",
    "resize-observer-polyfill": "^1.5.1",
    "ts-node": "^10.9.0",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.0.0",
    "webpack-bundle-analyzer": "^4.9.0"
  },
  "overrides": {
    "crypto-js": "^4.2.0"
  }
}
